var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramDonations40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Features-and-Benefits",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Donations64*",
    transform: "translate(5.500000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(2.718750, 8.609375)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand",
    transform: "translate(0.000000, 0.277722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.53125,9.69102823 C4.53125,9.69102823 12.9663462,11.9566532 13.59375,11.9566532 C14.2211538,11.9566532 24.46875,6.97227823 24.46875,6.97227823 C24.46875,6.97227823 24.2596154,4.25352823 21.75,4.25352823 C21.1225962,4.25352823 17.21875,5.15977823 17.21875,5.15977823 C17.21875,5.15977823 17.2884615,3.34727823 15.40625,3.34727823 C13.5240385,3.34727823 13.140625,3.34727823 13.140625,3.34727823 C13.140625,3.34727823 12.4169083,0.622665036 9.515625,1.08165323 C9.515625,1.08165323 5.10377455,1.98790323 5.4375,1.98790323 C4.81009615,1.98790323 4.39182692,3.36189516 4.39182692,3.36189516 L4.53125,9.69102823 Z",
    id: "Path-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.21875,5.15977823 C17.21875,5.15977823 17.21875,6.97227823 15.95,6.97227823 L10.875,6.97227823",
    id: "Path-10",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    fill: "#FFCC00",
    x: 0,
    y: 0.175403226,
    width: 5.4375,
    height: 10.875
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramDonations40);
export default __webpack_public_path__ + "static/media/pictogramDonations40.3fc3a4be8998cde660190aa4882b2729.svg";
export { ForwardRef as ReactComponent };